const fr = require("./language_json/fr.json");

export default fr;
